const { cELM, Wrap4ArrowMulti } = require("../../utils");
const Chat = require("../../chat");

class TimeInput {
  constructor(data) {
    this.data = data;
    this.element = cELM("div", "option-block");
    this.__elements = null;
    this.createElement();
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    return this.element;
  }

  createElement() {
    const _self = this;
    const inputContainer = cELM("div", "inputs-wrapper");
    const hourEl = cELM("input", "number-input");
    const hourWp = Wrap4ArrowMulti(hourEl, true);
    const spliter = cELM("div", "slash", ": ");
    const minEl = cELM("input", "number-input");
    const minWp = Wrap4ArrowMulti(minEl);
    const amEl = cELM("div", "toggle", "AM");

    hourEl.type = "number";
    minEl.type = "number";
    hourEl.autofocus = true;

    hourEl.placeholder = "9";
    minEl.placeholder = "15";
    amEl.placeholder = "AM";

    hourEl.pattern = "[0-9]*";
    minEl.pattern = "[0-9]*";

    const buttonEl = cELM("div", "continue-button", getLngTxt("button.continue"));

    // validator
    function validate(silent = false) {
      let isValid = true;

      if (!silent) {
        hourEl.classList.remove("invalid");
        minEl.classList.remove("invalid");
      }

      if (hourEl.value.length === 0 || Number(hourEl.value) > 12) {
        isValid = false;
        if (!silent) {
          hourEl.classList.add("invalid");
          hourEl.focus();
        }
      }

      if (minEl.value.length === 0 || Number(minEl.value) >= 60) {
        isValid = false;
        if (!silent) {
          minEl.classList.add("invalid");
          minEl.focus();
        }
      }

      return isValid;
    }

    // event listeners
    buttonEl.onclick = function(evt) {
      if (!validate()) return;

      hourEl.blur();
      minEl.blur();
      hourEl.blur();
      minEl.blur();

      const op = hourEl.value + ":" + minEl.value.padStart(2, "0") + " " + amEl.innerHTML;
      
      Chat.default.send({
          text: op,
          id: _self.data.id
        }, 
        null, 
        _self.element
      );
    };

    amEl.onclick = function(evt) {
      if (amEl.innerText === "AM") amEl.innerText = "PM";
      else amEl.innerText = "AM";
    };

    const onKeyUp = (el, nextEl, type) => function(evt) {
      var kc = evt.which || evt.keyCode;
      if (!kc || kc == 229) {
        const ss = evt.target.selectionStart - 1;
        const ssv = ss || 0;
        const char = evt.target.value.substr(ssv, 1);
        kc = char.charCodeAt(0);
      }

      if (el.value.length < 2 && type === 'hour') {
        if (kc > 49) {
          nextEl && nextEl.focus();
        }
      } else if (el.value.length < 2 && type === 'min') {
        if (kc > 53) {
          // bigger than 6
          nextEl ? nextEl.focus() : el.blur();
        }
      }

      if (el.value.length > 2) {
        el.value = el.value.slice(0, 2);
      } else if (el.value.length >= 2) {
        nextEl ? nextEl.focus() : el.blur();
      }

      if (validate(true)) {
        buttonEl.classList.add("continue-button-active");
      } else {
        buttonEl.classList.remove("continue-button-active");
      }
    };

    const onFocusChange = function(evt) {
      hourWp.classList.remove("arrow-active");
      minWp.classList.remove("arrow-active");

      if (evt && evt.target) {
        evt.target.parentNode.classList.add("arrow-active");
      }
    };

    // bind events
    hourEl.onfocus = onFocusChange;
    minEl.onfocus = onFocusChange;
    hourEl.onkeyup = onKeyUp(hourEl, minEl, 'hour');
    minEl.onkeyup = onKeyUp(minEl, null, 'min');

    // add elements to container
    hourWp.addELM(hourEl);
    inputContainer.addELM(hourWp);
    inputContainer.addELM(spliter);
    minWp.addELM(minEl);
    inputContainer.addELM(minWp);
    inputContainer.addELM(amEl);

    this.element.addELM(inputContainer);
    this.element.addELM(buttonEl);

    // store each element for references
    this.__elements = { minEl, hourEl, amEl };
    return this.element;
  }

  reset() {
    if (!this.__elements) return;
    this.__elements.hourEl.value = "";
    this.__elements.minEl.value = "";
    this.__elements.hourEl.focus();
  }

  focus() {
    if (!this.__elements) return;
    //this.__elements.hourEl.focus();
  }
}

module.exports = TimeInput;
